
<template>
    <div class="space-y-4 px-6 bg-black" style="padding-bottom: 25%; padding-top: 2%;">
    <h2 v-if="!currentPagePaymentHistory" class="text-xl text-white font-semibold" style="display: flex; justify-content: center;">Credits</h2>
    <h2 v-if="currentPagePaymentHistory" class="text-xl text-white font-semibold" style="display: flex; justify-content: center;">Payment History</h2>
    <div class="flex flex-row justify-end">
    <a v-if="!currentPagePaymentHistory" class="text-sm link underline text-white mr-2" @click="getPaymentHistory">Payment History</a>
    <a v-if="currentPagePaymentHistory" class="text-sm link underline text-white mr-2" @click="currentPagePaymentHistory = !currentPagePaymentHistory">Back</a>
    </div>
        <fieldset v-if="currentPagePaymentHistory" class="fieldset space-y-4">
            <loadingSpinner v-if="loadingSpinner" :loadingname=loadingname />
            <div >
            <div class="pt-4 flex flex-col">   
              <details 
              v-for="payment in paymentHistory"
              :key="payment.id"
              tabindex="0"  
              class="rounded-xl text-white bg-black mb-2 p-2 border border-white/30">

              <summary
              >
              <div style="justify-content: space-between;" class="flex flex-row">
                <span
                class="text-lg m2 p-2 font-semibold"
                >
                {{payment.created_at.split("T")[0]}}
              </span>
              <span 
              :class="['m-2 p-2 rounded-md text-black text-xs font-bold', payment.status == paymentStatus.COMPLETE ?'bg-green-600' : payment.status == paymentStatus.FAILURE ? 'bg-red-600':'bg-yellow-600' ]"
              >{{payment.status}}</span>
            </div>
            </summary >
              <div class="text-sm font-semibold">
                  <div class="flex flex-col m-2 items-center text-center justify-center">
                    <label class="" >Transaction ID</label>
                    <label class="" >{{ payment.id }}</label>
                  </div>
                  <div class="m-2">                    
                    <div class="flex flex-row" style="justify-content: space-between;">
                    <label >{{ payment.source }}</label>
                    <label >Amount: {{ payment.amount }}</label>
                    </div>
                    <div class="flex flex-row" style="justify-content: space-between;">
                    <a v-if="payment.status == paymentStatus.PENDING & payment.source != paymentSource.DIRECT_UPI" :href="payment.paid_to" target="_blank"  class="link underline text-white">Payment Link</a>
                    <a v-if="payment.status == paymentStatus.PENDING" class="flex flex-col text-white">Pay to UPI ID:
                    <span class="text-blue-600">{{payment.paid_to}}</span>  
                    </a>
                    <label >Charges: {{ payment.payment_charges }}</label>
                    </div>
                  </div>
                  <div class="flex justify-center items-center" v-if="payment.status == paymentStatus.PENDING">
                  <button v-if="payment.source == paymentSource.PG_CASHFREE" ref="recheckPaymentStatus"  class="flex flex-row justify-center items-center rounded-md text-xl text-black font-semibold bg-white"  style="height: 100%;">
                  <span v-if="!payment.checkingStatus" @click="checkPaymentStatus(payment.id)" class="pr-2 pl-2 m-2 text-sm" >Recheck status</span>
                  </button>  
                  <span v-if="payment.checkingStatus"  class="loading loading-dots loading-xl pr-2 pl-2 m-2"></span>
                  </div>
              </div>
            </details>    
            </div>
            </div>
    </fieldset>
    <fieldset v-if="!currentPagePaymentHistory" class="fieldset">
          <div class="flex justify-between bg-gray-100 p-0.5 rounded-md">
            <button @click="manualPaymentMode = !manualPaymentMode" :class="['flex-1 text-center py-2 rounded-md font-semibold font-medium', manualPaymentMode ? 'bg-black text-white shadow text-sm': '']">
              Direct UPI
            </button>
            <button @click="manualPaymentMode = !manualPaymentMode, manualPaymentModeOptions = false" :class="['flex-1 text-center py-2 rounded-md font-semibold font-medium', !manualPaymentMode ? 'bg-black text-white shadow text-sm': '']">
              Payment Gateway
            </button>
          </div>
            <label v-if="manualPaymentMode" class="text-sm pt-1 pb-1 text-white font-base text-center">No Charges but credits will reflect next day.</label>        
            <label v-if="!manualPaymentMode" class="text-sm pt-1 pb-1 text-white font-base text-center">Payment Gateway Charges of 
              <span class="text-lg font-bold text-blue-500" >2.36%</span>
              will be added at checkout.</label>            
            <input v-model="credits" type="number" min="100" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="Amount" style="width: 100%; height: 3rem;" />            
            <input  v-if="!manualPaymentMode" v-model="phoneNo" class="w-full mt-3 px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="Phone No" style="width: 100%; height: 3rem;" />            
            <span></span>
            
            <button ref="addCreditsBtn" name = "add" @click="add" class="rounded-md text-xl mt-2 text-black font-semibold bg-white"  style="height:2.75rem; width: 100%;">
              <span v-if="!loading" >Add Credits</span>
              <span v-if="loading" class="loading loading-dots loading-xl"></span>
            </button>  
            <div v-show="manualPaymentModeOptions" >
            <div class="pt-4 flex flex-row" style="justify-content: space-between;">
            <a  class="items-center flex flex-col text-white text-center" :href="`phonepe://upi/pay?pa=${paymentData.paid_to}&am=${paymentData.amount}&cu=INR&tn=${paymentData.id}&tr=${paymentData.id}`">
            <svg class="size-[3em]" xmlns="http://www.w3.org/2000/svg" version="1.1" id="_x32_" x="0" y="0" height="800px" width="800px" viewBox="0 0 44 44" xml:space="preserve" fill="#5f259f"><circle fill="#5f259f" class="st0" cx="22" cy="22" r="22"/>
              g
            <path transform="translate(3.75, 0)" d="M26 19.3c0-.7-.6-1.3-1.3-1.3h-2.4l-5.5-6.3c-.5-.6-1.3-.8-2.1-.6l-1.9.6c-.3.1-.4.5-.2.7l6 5.7H9.5c-.3 0-.5.2-.5.5v1c0 .7.6 1.3 1.3 1.3h1.4v4.8c0 3.6 1.9 5.7 5.1 5.7 1 0 1.8-.1 2.8-.5v3.2c0 .9.7 1.6 1.6 1.6h1.4c.3 0 .6-.3.6-.6V20.8h2.3c.3 0 .5-.2.5-.5v-1zm-6.4 8.6c-.6.3-1.4.4-2 .4-1.6 0-2.4-.8-2.4-2.6v-4.8h4.4v7z" fill="#fff"/>
            </svg>
            <span><strong>Phonepe</strong></span> 
            </a>
            <a class="items-center flex flex-col text-white text-center" :href="`gpay://upi/pay?pa=${paymentData.paid_to}&am=${paymentData.amount}&cu=INR&tn=${paymentData.id}`">
            <svg class="size-[3em]" xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="-3 0 262 262" preserveAspectRatio="xMidYMid"><path d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027" fill="#4285F4"/><path d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1" fill="#34A853"/><path d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782" fill="#FBBC05"/><path d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251" fill="#EB4335"/></svg>
            <span><strong>Google Pay</strong></span> 
            </a>
            <a class="items-center flex flex-col text-white text-center" :href="`paytm://upi/pay?pa=${paymentData.paid_to}&am=${paymentData.amount}&cu=INR&tn=${paymentData.id}`">
            <svg class="size-[3em]" xmlns="http://www.w3.org/2000/svg" fill="currentcolor" width="800px" height="800px" viewBox="0 0 32 32" version="1.1">
            <title>paytm</title>
            <path d="M8.773 17.193h0.556c0.002-0 0.004-0 0.007-0 0.167 0 0.304 0.133 0.308 0.3v1.165c-0 0.034-0.007 0.067-0.018 0.097l0.001-0.002c-0.045 0.121-0.159 0.205-0.293 0.205-0.001 0-0.003 0-0.004-0h-0.556c-0.002 0-0.004 0-0.006 0-0.167 0-0.304-0.133-0.309-0.3v-1.166c0.005-0.166 0.14-0.299 0.307-0.299 0.003 0 0.005 0 0.008 0h-0zM2.938 14.723h0.847c0.173 0.002 0.312 0.143 0.312 0.316 0 0.002 0 0.003-0 0.004v-0 1.045c0 0.001 0 0.003 0 0.004 0 0.173-0.139 0.314-0.312 0.316h-0.125c-0.24 0.003-0.482 0-0.722 0zM7.577 12.758c-0.002-0-0.005-0-0.008-0-0.158 0-0.286 0.126-0.29 0.282v1.279c0.005 0.167 0.141 0.3 0.308 0.3 0.002 0 0.005-0 0.007-0h1.765c0.145 0.021 0.257 0.14 0.266 0.287l0 0.001v0.175c-0.008 0.144-0.117 0.261-0.257 0.28l-0.002 0h-0.875c-0.036-0.002-0.079-0.004-0.121-0.004-1.033 0-1.871 0.838-1.871 1.871 0 0.009 0 0.018 0 0.027l-0-0.001v1.586c-0.002 0.035-0.004 0.076-0.004 0.117 0 0.977 0.792 1.768 1.768 1.768 0.036 0 0.073-0.001 0.108-0.003l-0.005 0h2.424c0.005 0 0.011 0 0.017 0 0.418 0 0.759-0.333 0.77-0.749l0-0.001v-5.169c0.007-0.061 0.011-0.132 0.011-0.203 0-1.030-0.835-1.866-1.866-1.866-0.104 0-0.206 0.008-0.306 0.025l0.011-0.001zM12.581 12.751c-0.164 0.001-0.296 0.135-0.296 0.299 0 0.001 0 0.002 0 0.003v-0 3.087c-0.002 0.028-0.002 0.062-0.002 0.095 0 1.058 0.858 1.915 1.915 1.915 0.021 0 0.042-0 0.063-0.001l-0.003 0h0.844c0.017 0 0.033 0.002 0.048 0.005l-0.002-0c0.157 0.021 0.277 0.154 0.277 0.315 0 0.16-0.118 0.292-0.272 0.314l-0.002 0-0.023 0.005-0.379 0.008h-1.576c-0.163 0.002-0.295 0.135-0.295 0.299 0 0 0 0.001 0 0.001v-0 1.362c0 0.001 0 0.002 0 0.002 0 0.164 0.131 0.297 0.295 0.3h2.187c0.017 0.001 0.037 0.001 0.057 0.001 1.058 0 1.916-0.858 1.916-1.916 0-0.033-0.001-0.066-0.003-0.099l0 0.005v-5.698c0-0 0-0.001 0-0.001 0-0.164-0.132-0.297-0.295-0.299h-1.337c-0.163 0.002-0.295 0.135-0.295 0.299 0 0 0 0.001 0 0.001v-0c-0.006 0.983 0 1.906 0 2.818-0.002 0.172-0.141 0.31-0.312 0.312h-0.561c-0.173-0.002-0.312-0.143-0.312-0.316 0-0.001 0-0.002 0-0.003v0c0.006-0.942-0.006-1.874-0.006-2.812 0-0 0-0.001 0-0.001 0-0.164-0.132-0.297-0.295-0.299h-0zM1.294 12.751c-0.16 0.001-0.29 0.132-0.29 0.292 0 0.001 0 0.002 0 0.003v-0 7.403c-0 0.004-0 0.008-0 0.012 0 0.153 0.119 0.278 0.269 0.289l0.001 0h1.362c0.164-0.001 0.296-0.134 0.296-0.298 0-0.001 0-0.001 0-0.002v0l0.005-2.072h1.278c0.020 0.001 0.044 0.001 0.068 0.001 0.967 0 1.75-0.784 1.75-1.75 0-0.036-0.001-0.071-0.003-0.106l0 0.005v-1.922c0.002-0.031 0.003-0.067 0.003-0.103 0-0.968-0.785-1.753-1.753-1.753-0.023 0-0.046 0-0.069 0.001l0.003-0zM26.091 12.672c-0.5 0.001-0.957 0.188-1.304 0.495l0.002-0.002v-0.155c-0.009-0.155-0.136-0.278-0.292-0.28h-1.337c-0.163 0.003-0.295 0.136-0.295 0.3 0 0.001 0 0.002 0 0.003v-0 7.398c0 0.001 0 0.002 0 0.002 0 0.164 0.131 0.297 0.295 0.3h1.337c0.15-0.002 0.273-0.114 0.291-0.26l0-0.001v-5.311c-0-0.006-0-0.013-0-0.019 0-0.262 0.205-0.476 0.463-0.49l0.001-0h0.245c0.108 0.009 0.205 0.050 0.283 0.113l-0.001-0.001c0.111 0.093 0.181 0.233 0.181 0.388 0 0.004-0 0.007-0 0.011v-0.001 5.091l0.005 0.194c0 0 0 0.001 0 0.001 0 0.164 0.132 0.298 0.296 0.3h1.337c0.159-0.003 0.288-0.129 0.294-0.287l0-0.001-0.001-5.306c-0-0.004-0-0.008-0-0.013 0-0.17 0.085-0.321 0.216-0.411l0.002-0.001c0.069-0.046 0.153-0.077 0.243-0.085l0.002-0h0.247c0.259 0.018 0.463 0.232 0.463 0.494 0 0.005-0 0.011-0 0.016l0-0.001c0.006 1.744 0.005 3.499 0.005 5.278 0 0 0 0.001 0 0.001 0 0.164 0.132 0.298 0.296 0.3h1.337c0.163-0.002 0.295-0.135 0.295-0.298 0-0.001 0-0.002 0-0.003v0-5.677c0.002-0.029 0.002-0.063 0.002-0.097 0-0.223-0.038-0.438-0.107-0.638l0.004 0.014c-0.274-0.796-1.014-1.358-1.886-1.362h-0.019c-0.567 0-1.079 0.24-1.439 0.624l-0.001 0.001c-0.361-0.385-0.873-0.624-1.441-0.625h-0zM20.811 11.21c-0.018 0-0.035 0.002-0.052 0.005l0.002-0c-0.85 0.237-0.679 1.435-2.226 1.537h-0.15c-0.002-0-0.003-0-0.005-0-0.021 0-0.042 0.002-0.062 0.007l0.001-0c-0.133 0.033-0.23 0.151-0.23 0.292 0 0.001 0 0.001 0 0.002v-0 1.362c0 0.001-0 0.002-0 0.003 0 0.164 0.132 0.297 0.296 0.298h0.806v5.777c0 0.001-0 0.002-0 0.004 0 0.161 0.13 0.292 0.291 0.294h1.322c0.161-0.002 0.291-0.133 0.291-0.295 0-0.001 0-0.002 0-0.003v0-5.777h0.75c0.163-0.002 0.295-0.134 0.295-0.298 0-0.001 0-0.002-0-0.004v0-1.362c0-0 0-0.001 0-0.001 0-0.164-0.132-0.297-0.295-0.299h-0.765v-1.268c0-0.001 0-0.002 0-0.003 0-0.15-0.121-0.271-0.27-0.272h-0z"/>
            </svg>
            <span><strong>Paytm</strong></span> 
            </a>
            <a class="items-center flex flex-col text-white text-center" :href="`upi://pay?pa=${paymentData.paid_to}&am=${paymentData.amount}&cu=INR&tn=${paymentData.id}`">
            <svg class="size-[3em]" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill-rule="evenodd"><path d="M55.05 32.542L38.715 0l-18.15 64z" fill="#097939"/><path d="M43.433 32.542L27.1 0 8.95 64z" fill="#ed752e"/></svg>
            <span><strong>Upi</strong></span>   
            </a>
            </div>        
            <div class="flex flex-col pt-4">
            <label class="text-lg text-white font-bold text-center">Transaction Reference ID<br></label>
            <span class="text-center text-white text-sm flex flex-col justify-center items-center font-thin">{{ paymentData.id }}
            <button class="flex justify-center items-center" @click="copyTransactionId">
            <svg class="pl-2 size-[2em]" focusable="true" fill="white" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24"><g><rect fill="none" height="24" width="24"></rect></g><g><path d="M16,20H5V6H3v14c0,1.1,0.9,2,2,2h11V20z M20,16V4c0-1.1-0.9-2-2-2H9C7.9,2,7,2.9,7,4v12c0,1.1,0.9,2,2,2h9 C19.1,18,20,17.1,20,16z M18,16H9V4h9V16z"></path></g></svg>
            <span>{{copyLabel}}</span>
            </button>
            </span>
            <div class="flex items-center justify-center pr-8 pl-8 pt-4 pb-2">
            <qrcode class="w-50 rounded-3xl" :value="`upi://pay?pa=${paymentData.paid_to}&am=${paymentData.amount}&cu=INR&tn=${paymentData.id}`" :size="100" />
            </div>
            <div class="flex items-center justify-center pr-8 pl-8 pb-10">
            <label class="text-sm text-white font-thin text-center">If link does not work, scan QR and make payment.<br>
              Ensure <span class="text-red-600 font-bold">Transaction Reference ID</span> 
              alone is provided as note in UPI payment.
            <br></label> 
            </div>
            </div>
            </div>
    </fieldset>
    </div>
</template>

<script>
import { apiCall, paymentStatus, paymentSource } from '@/js/main';
import QRCode from 'vue-qrcode'
import loadingSpinner from './loading.vue';

export default {
  name: "fundsPage",
  components:{
      qrcode: QRCode,
      loadingSpinner: loadingSpinner
  },
  data(){
    return {
      copyLabel: "Copy",
      credits: 100,
      loading: false,
      manualPaymentMode: true,
      manualPaymentModeOptions: false,
      paymentData: {
        source: "",
        amount: 0,
        paid_to: '',
        id: ''
      }      ,
      phoneNo: '',
      currentPagePaymentHistory: false,
      loadingSpinner: false,
      paymentHistory: [],
      paymentStatus: paymentStatus,
      paymentSource: paymentSource
    }
  },
  methods:{
     async checkPaymentStatus(id){
      const payment = this.paymentHistory.find(r => r.id === id);
      payment.checkingStatus = true
      var data = await apiCall("/payment/pg-cashfree/check-status/"+payment.id, "GET", null)    
      
     if (data.success){

      if (data.data.status == paymentStatus.COMPLETE){
          this.$emit('push-alert', true, "Credits added successfully!")
          this.$emit('update-credits', data.data.amount)
          payment.status = paymentStatus.COMPLETE           
      }
      else{
        this.$emit('push-alert', false, "Payment not received yet")
      }
      }
      else {
        this.$emit('push-alert', false, data.error_message)
      }

      payment.checkingStatus = false

     },

    async getPaymentHistory(){
      this.paymentHistory = []
      this.currentPagePaymentHistory = !this.currentPagePaymentHistory
      this.loadingSpinner =  true

      var data = await apiCall("/payment/all", "GET", null)      

      if (data.success){
        this.paymentHistory = data.data

        this.paymentHistory = this.paymentHistory.map(r => ({
            ...r,
            checkingStatus: false,
            }));
      }
      else {
        this.$emit('push-alert', false, data.error_message)
      }
      this.loadingSpinner =  false

    },

    copyTransactionId(){
      this.copyLabel = "Copied!"
      const el = document.createElement("textarea");
      el.value = this.paymentData.id
      document.body.appendChild(el);
      el.select();                       // ✅ select it
      document.execCommand("copy");     // ✅ now it copies
      document.body.removeChild(el);

    },
    async add(){
      this.copyLabel = "Copy"
      if (!Number.isInteger(Number(this.credits))){
        this.$emit('push-alert', false, "Enter valid number")
      }
      else{
      const input =  this.$refs.addCreditsBtn
      input.disabled = true
      this.loading = true
      
      if(this.manualPaymentMode){

        // make api call
      var data = await apiCall("/payment/direct-upi/"+this.credits, "GET", null)      


          if (data.success){
            this.paymentData = data.data
            this.manualPaymentModeOptions = true
          }
          else {
            this.$emit('push-alert', false, data.error_message)
          }
        
      }
      else{
        
      if (Number.isInteger(Number(this.phoneNo)) && this.phoneNo > 6000000000 && this.phoneNo < 10000000000){
      // make api call  
      const win = window.open("", "_blank")

      var data = await apiCall("/payment/pg-cashfree/create?amount="+this.credits+"&phone_no="+this.phoneNo, "GET", null)      
        
      if (data.success){
        const paymentLink = data.data.link
        var paymentSuccess = false
        win.location.href = paymentLink
      
        function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));        }


        for(let i=0; i<3; i++){

          //Poll for 30seconds
          await sleep(60000);

          // Check payment status
          var data = await apiCall("/payment/pg-cashfree/check-status/"+data.data.id, "GET", null)      

          if (data.data.status == "COMPLETE"){
            this.$emit('push-alert', true, "Credits added successfully!")
            this.$emit('update-credits', data.data.amount)
            paymentSuccess = true            
            break
          }
        }
        
        if (!paymentSuccess){
            this.$emit('push-alert', false, "Transaction status could not be validated. Please check transaction history.")
        }
     
        }
        else {
            win.close()
            this.$emit('push-alert', false, data.error_message)
          }
      this.credits = 100
      this.phoneNo = ''
      }
      else {
        this.$emit('push-alert', false, "Invalid Phone no")
        }
      }
      
      
      this.loading = false     
      input.disabled = false
    }} 

  },
  beforeMount(){
    window.scrollTo({ top: 0, behavior: 'auto' })
  }
}
</script>

<style scoped>
details > summary {
  list-style: none;
  cursor: pointer;
}

details > summary::-webkit-details-marker {
  display: none;
}
</style>